import { render, staticRenderFns } from "./add-new-case.vue?vue&type=template&id=e1a7eef0&"
import script from "./add-new-case.vue?vue&type=script&lang=js&"
export * from "./add-new-case.vue?vue&type=script&lang=js&"
import style0 from "./add-new-case.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports